import { Controller } from "@hotwired/stimulus";

var HubStaffContactsController = class extends Controller {
  connect() {
    if (this.hasCompanyPanelTarget || this.hasEventPanelTarget) {
      this._handleOutsideClick = (e) => {
        if (!this.element.contains(e.target)) this._closeAllPanels();
      };
      window.addEventListener("click", this._handleOutsideClick);
      if (this.hasCompanySearchTarget) {
        this._updateSelectionLabel(
          this.companySearchTarget,
          this.companyItemTargets,
          this.companySearchTarget.dataset.placeholder,
        );
      }
      if (this.hasEventSearchTarget) {
        this._updateSelectionLabel(
          this.eventSearchTarget,
          this.eventItemTargets,
          this.eventSearchTarget.dataset.placeholder,
        );
      }
    }
  }

  disconnect() {
    if (this._handleOutsideClick) {
      window.removeEventListener("click", this._handleOutsideClick);
    }
  }

  toggleAllHubs() {
    const checked = this.allHubsTarget.checked;
    this.hubCompanyFieldTarget.style.display = checked ? "none" : "";
    const select = this.hubCompanyFieldTarget.querySelector("select");
    if (select) select.disabled = checked;
  }

  toggleNoEvent() {
    this.eventFieldTarget.hidden = this.noEventTarget.checked;
  }

  openCompanyDropdown() {
    if (!this.hasCompanyPanelTarget || !this.companyPanelTarget.hidden) return;
    this.companyPanelTarget.hidden = false;
    this.companySearchTarget.value = "";
    this.companyItemTargets.forEach((item) => {
      item.style.display = "";
    });
  }

  openEventDropdown() {
    if (!this.hasEventPanelTarget || !this.eventPanelTarget.hidden) return;
    this.eventPanelTarget.hidden = false;
    this.eventSearchTarget.value = "";
    this.eventItemTargets.forEach((item) => {
      item.style.display = "";
    });
  }

  filterCompanies() {
    if (this.hasCompanyPanelTarget) this.companyPanelTarget.hidden = false;
    const query = this.companySearchTarget.value.toLowerCase();
    this.companyItemTargets.forEach((item) => {
      item.style.display = item.textContent.trim().toLowerCase().includes(query)
        ? ""
        : "none";
    });
  }

  filterEvents() {
    if (this.hasEventPanelTarget) this.eventPanelTarget.hidden = false;
    const query = this.eventSearchTarget.value.toLowerCase();
    this.eventItemTargets.forEach((item) => {
      item.style.display = item.textContent.trim().toLowerCase().includes(query)
        ? ""
        : "none";
    });
  }

  onCompanyChange() {
    this._updateSelectionLabel(
      this.companySearchTarget,
      this.companyItemTargets,
      this.companySearchTarget.dataset.placeholder,
    );
  }

  onEventChange() {
    this._updateSelectionLabel(
      this.eventSearchTarget,
      this.eventItemTargets,
      this.eventSearchTarget.dataset.placeholder,
    );
  }

  _closeAllPanels() {
    if (this.hasCompanyPanelTarget && !this.companyPanelTarget.hidden) {
      this.companyPanelTarget.hidden = true;
      this.companySearchTarget.value = "";
      this.companyItemTargets.forEach((item) => {
        item.style.display = "";
      });
      this._updateSelectionLabel(
        this.companySearchTarget,
        this.companyItemTargets,
        this.companySearchTarget.dataset.placeholder,
      );
    }
    if (this.hasEventPanelTarget && !this.eventPanelTarget.hidden) {
      this.eventPanelTarget.hidden = true;
      this.eventSearchTarget.value = "";
      this.eventItemTargets.forEach((item) => {
        item.style.display = "";
      });
      this._updateSelectionLabel(
        this.eventSearchTarget,
        this.eventItemTargets,
        this.eventSearchTarget.dataset.placeholder,
      );
    }
  }

  _updateSelectionLabel(input, items, defaultPlaceholder) {
    const count = items.filter(
      (item) => item.querySelector('input[type="checkbox"]').checked,
    ).length;
    input.placeholder =
      count > 0 ? `${count} valittu` : defaultPlaceholder || input.placeholder;
  }
};

HubStaffContactsController.targets = [
  "allHubs",
  "hubCompanyField",
  "noEvent",
  "eventField",
  "companySearch",
  "companyPanel",
  "companyItem",
  "eventSearch",
  "eventPanel",
  "eventItem",
];

export default HubStaffContactsController;
